/**
 * user mutations
 */
export const STORE_USER = 'STORE_USER';
export const CLEAR_AUTH_DATA = 'CLEAR_AUTH_DATA';
export const SHOW_LOGIN_ERRORS = 'SHOW_LOGIN_ERRORS';

/**
 * promotion mutations
 */
export const STORE_PROMOTION = 'STORE_PROMOTION';
export const WAIT_DATA_TO_BE_LOADED = 'WAIT_DATA_TO_BE_LOADED';
